/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfAnnouncementDto } from '../../models/platform-api-result-of-announcement-dto';
import { PlatformCreateAnnouncement } from '../../models/platform-create-announcement';

export interface PostNotificationsAnnouncements$Params {
      body: PlatformCreateAnnouncement
}

export function postNotificationsAnnouncements(http: HttpClient, rootUrl: string, params: PostNotificationsAnnouncements$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfAnnouncementDto>> {
  const rb = new RequestBuilder(rootUrl, postNotificationsAnnouncements.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfAnnouncementDto>;
    })
  );
}

postNotificationsAnnouncements.PATH = '/api/notifications/announcements';
